import { request } from '../methods'

export default {
  mark_read: request('put', '/api/v1/comments/{pk}/mark_read/'),
  mark_policy_read: request('put', '/api/v1/comments/mark_read/policy/{policy_pk}/'),
  mark_application_read: request('put', '/api/v1/comments/mark_read/app/{app_pk}/'),
}
